<template>
  <div>
    <ts-loading-banner :loading="waiting">
      <div class="row">
        <div class="col-md-12">
          <label>{{ $t('groupTracking.groupName') }}</label>
          <input
            v-model.trim="model.group_name"
            type="text"
            class="form-control"
          />
          <div class="validate" v-if="errors.has('group_name')">
            {{ errors.first('group_name') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 ts-mt-3 text-right">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t('cancel') }}
          </ts-button>
          <ts-button
            v-if="!isUpdate"
            class="mr-2"
            color="primary"
            outline
            @click.prevent="onSaveAddNew"
            >{{ $t('save_add_new') }}</ts-button
          >
          <ts-button v-if="!isUpdate" color="primary" @click.prevent="onSave">{{
            $t('save')
          }}</ts-button>
          <ts-button
            v-if="isUpdate"
            color="primary"
            @click.prevent="onUpdate"
            >{{ $t('update') }}</ts-button
          >
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import { isEmpty } from 'lodash'
export default {
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      model: {
        id: '',
        group_name: ''
      }
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('sale/groupTracking', ['edit_data']),
    isUpdate() {
      return !isEmpty(this.edit_data)
    }
  },
  methods: {
    onSaveAddNew() {
      this.waiting = true
      this.errors = new Errors()
      this.$store
        .dispatch('sale/groupTracking/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('sale/groupTracking/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('sale/groupTracking/update', {
          id: this.model.id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    clearInput() {
      this.model.id = ''
      this.model.group_name = ''
    },
    async setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.id = this.edit_data.id
        this.model.group_name = this.edit_data.group_name
      }
    }
  }
}
</script>
